<template>
  <MainApp />
</template>

<script>
import MainApp from './MainApp.vue'

export default {
  name: 'App',
  components: {
    MainApp
  }
}
</script>
